import React from "react";
import { Popconfirm } from "antd";

import Button from "../Button";

function ConfirmButton({ children, popProps, buttonProps }) {
  return (
    <Popconfirm {...popProps} placement="topLeft">
      <Button
        {...buttonProps}
        onClick={
          popProps.disabled
            ? (buttonProps && buttonProps.onClick) || popProps.onConfirm
            : undefined
        }
      >
        {children}
      </Button>
    </Popconfirm>
  );
}

export default ConfirmButton;
